module.exports = __webpack_public_path__ + "img/loading.b721217a.png";